module.exports = __webpack_public_path__ + "static/media/nft-domain-icon1.c3a34fc3.svg";